/**
 * Updates 'delivery-date' text to reflect size chosen
 * @module updateDeliveryDate
 */

import $ from 'jquery';

export const EL_CLASS = 'delivery-date';
export const LABEL_DATA_ATTR = 'label';

/**
 * Initializes 'estimated delivery' text changes.
 * @param {HTMLElement} wrap - The closest wrap from the select
 * @param {Object} chosen - Information on the selected size
 * @return {jQuery} delivery-date element
 */
export default function updateDeliveryDate({ wrap, chosen = {} }) {
  const { 'delivery-date': deliveryDate } = chosen;

  const $el = $(wrap).find(`.${EL_CLASS}`);
  const label = $el.data(LABEL_DATA_ATTR);

  if (deliveryDate) {
    $el.html(`${label} ${deliveryDate}`);
  } else {
    $el.empty();
  }

  return $el;
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/delivery-date-update.js